import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './DocumentPage.css'

const GettingStartedIndex = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>Getting Started</h1>
        <p className="lead">
          Welcome to the Variable Modding System! This guide will help you get up and running quickly.
        </p>

        <h2>Quick Start Guide</h2>
        <p>Follow these steps to start using the Variable Modding System:</p>

        <div style={{ marginTop: '2rem' }}>
          <h3><Link to="/getting-started/installation">1. Installation</Link></h3>
          <p>Download and install the plugin from the Fab marketplace into your Unreal Engine project.</p>

          <h3><Link to="/getting-started/initial-configuration">2. Initial Configuration</Link></h3>
          <p>Set up your first CSV configuration and understand the basic settings.</p>

          <h3><Link to="/getting-started/in-editor-testing">3. In-Editor Testing</Link></h3>
          <p>Test your configuration directly in the Unreal Engine editor.</p>

          <h3><Link to="/getting-started/in-game-testing">4. In-Game Testing</Link></h3>
          <p>Deploy and test your variables in a running game instance.</p>
        </div>

        <h2>What You'll Learn</h2>
        <ul>
          <li>How to install and enable the Variable Modding System</li>
          <li>Creating your first CSV configuration</li>
          <li>Testing variables in both editor and game modes</li>
          <li>Understanding the basic workflow</li>
        </ul>

        <h2>Prerequisites</h2>
        <ul>
          <li>Unreal Engine 5.0 or higher</li>
          <li>Basic familiarity with Unreal Engine</li>
          <li>Purchase from Fab marketplace</li>
        </ul>

        <h2>Need Help?</h2>
        <p>
          Join our <a href="https://discord.gg/WbbBfkNaxt" target="_blank" rel="noopener noreferrer">Discord community</a> for support and discussions.
        </p>
      </div>
    </div>
  )
}

export default GettingStartedIndex
